import { useEffect, useState } from "react";
import api from "../../api/axios";
import { getPublicAuthRequestConfig } from "./registrationAvailability";

const cityKey = (value) => String(value || "").trim().normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase();
export default function useRegistrationCities({ enabled, registrationRegion, geoCountry, geoCity,
  selectedCountry, query, accountRegion = "" }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    const controller = new AbortController();
    const text = String(query || "").trim();
    setOptions([]);
    setError(false);
    const country = accountRegion ? selectedCountry || "" : geoCountry || selectedCountry || "";
    if (text && text.length < 2) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const timer = setTimeout(async () => {
      try {
        const response = await api.get("/accounts/locations/cities/", {
          ...(accountRegion ? { meta: { suppressGlobalError: true } } : getPublicAuthRequestConfig()),
          params: { q: text, country }, signal: controller.signal,
        });
        if (cancelled) return;
        const remote = (Array.isArray(response.data?.cities) ? response.data.cities : [])
          .filter((option) => !accountRegion || ((option.country === "RU") === (accountRegion === "RU")));
        const geoName = cityKey(geoCity);
        const orderedRemote = !text && geoName && country !== "SK" ? [...remote].sort((a, b) => {
          const matches = (option) => cityKey(option.name) === geoName;
          return Number(matches(b)) - Number(matches(a));
        }) : remote;
        const registryNames = new Set(orderedRemote
          .filter((option) => option.municipality_id)
          .map((option) => option.country + ":" + option.name));
        const preferredRemote = orderedRemote.filter((option) => option.municipality_id
          || !registryNames.has(option.country + ":" + option.name));
        const seen = new Set();
        setOptions(preferredRemote.filter((option) => {
          const key = option.municipality_id
            ? "municipality:" + option.municipality_id
            : option.country + ":" + option.name;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        }));
      } catch (err) {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, text ? 250 : 0);
    return () => { cancelled = true; clearTimeout(timer); controller.abort(); };
  }, [enabled, accountRegion, registrationRegion, geoCountry, geoCity, selectedCountry, query]);
  return { options, loading, error };
}
